import React from "react";
import MapButtonsControl from "../../../components/map-report/map-buttons-control.jsx";

const SentryCloudSearchMapElements = ({mapState, setMapState}) => {
    return (
        <MapButtonsControl
            mapState={mapState}
            onTogglePOI={() => setMapState((previous) => ({...previous, pointsOfInterest: !previous.pointsOfInterest}))}
            onToggleNeighborhood={() => setMapState((previous) => ({...previous, neighborhoodStreets: !previous.neighborhoodStreets}))}
            usesMapId={true}
        />
    );
};

export default SentryCloudSearchMapElements;